import { gql } from '@apollo/client';

export const GET_CHAT_LIST = gql`
  query GetChatList($coachId: String!, $filterValue: String, $skip: Int!, $take: Int!) {
    getChatList(coachId: $coachId, filterValue: $filterValue, skip: $skip, take: $take) {
      totalRecordCount
      chats {
        id
        clientId
        coachId
        updatedAt
        createdAt
        chatMessages {
          id
          chatId
          message
          messageType
          senderType
          createdAt
          updatedAt
          messageSeen
        }
        client {
          id
          firstName
          lastName
          surname
          email
          profilePic
          dob
          gender
          tp
          addressLine1
          addressLine2
          city
          state
          pronoun
          createdAt
          updatedAt
          organizationId
          archived
          isActive
          inactivatedDate
          language
        }
      }
    }
  }
`;

export const GET_CLIENT_FOR_COACH = gql`
  query GetClientsForCoach(
    $coachId: String!
    $take: Int!
    $skip: Int!
    $nameText: String
    $isArchived: Boolean!
    $isOnlyClientName: Boolean
  ) {
    getClientsByCoachId(
      coachId: $coachId
      take: $take
      skip: $skip
      nameText: $nameText
      isArchived: $isArchived
      isOnlyClientName: $isOnlyClientName
    ) {
      totalClientCount
      clients {
        client {
          id
          firstName
          lastName
          profilePic
          surname
          email
          objectives {
            objectiveName
            colorCode
          }
          isActive
          updatedAt
        }
        engagementLevel {
          clientId
          engagementLevels {
            date
            engagementLevel
          }
        }
      }
      clientCountStatus
      subscriptionPlanStatus {
        daysLeft
        currentPlan
        paymentStatus
        nextPlan
      }
    }
  }
`;

export const SEARCH_CLIENTS = gql`
  query SearchClientNameList(
    $query: String!
    $clientGroupId: String
    $skip: Int = 0
    $take: Int = 10
  ) {
    searchClientNameList(query: $query, clientGroupId: $clientGroupId, skip: $skip, take: $take) {
      id
      email
      firstName
      lastName
      profilePic
      tp
      archived
    }
  }
`;

export const GET_CHAT_MESSAGES = gql`
  query GetChatMessages($coachId: String!, $clientId: String!, $skip: Int!, $take: Int!) {
    getChatMessages(coachId: $coachId, clientId: $clientId, skip: $skip, take: $take) {
      totalMessageCount
      chat {
        id
        clientId
        coachId
        updatedAt
        createdAt
      }
      messages {
        id
        chatId
        message
        messageType
        senderType
        createdAt
        updatedAt
        assetDuration
        messageSeen
        messageSent
        messageDelivered
      }
    }
  }
`;

export const UPDATE_MESSAGE_STATUS = gql`
  mutation updateMessageStatus($updateMessageStatusInput: UpdateMessageStatusInput!) {
    updateMessageStatus(updateMessageStatusInput: $updateMessageStatusInput) {
      message
      success
      statusCode
    }
  }
`;

export const SUBSCRIBE_TO_COACH_MESSAGES = gql`
  subscription SubscribeToCoachMessages($coachId: String!) {
    coachMessages(coachId: $coachId) {
      id
      clientId
      coachId
      updatedAt
      createdAt
      messageUpdateType
      client {
        id
        firstName
        lastName
        profilePic
        archived
      }
      chatMessages {
        id
        chatId
        message
        messageType
        senderType
        createdAt
        updatedAt
        assetDuration
        messageSeen
        messageSent
        messageDelivered
      }
    }
  }
`;
